import axios from "axios";
import axiosInstance from "../utils/axiosInstance";
import { Banner } from "../interfaces/banner.interface";
import { normalizeActiveStorageUrl } from "../utils/imageUrl";

class BannersApi {

  getBanners(category?: string): Promise<Banner[]> {
    const apiUrl = category ? `/api/v1/banner?category=${category}` : "/api/v1/banner";

    return axios.get(apiUrl)
    .then(response => {
      const banners = response.data.data.attributes.slides.map(slide => {
        const banner:Banner = {
          title: slide.title,
          url: slide.url,
          target: slide.target,
          sortOrder: slide.sort_order,
          desktopImage: normalizeActiveStorageUrl(slide.image.desktop),
          mobileImage: normalizeActiveStorageUrl(slide.image.mobile)
        }
        return banner;
      })
      return Promise.resolve(banners);
    });
  }

  // Tab-type-aware counterpart to getBanners(), backed by B2C2B::Api::V1::SlidesController
  // (#4449) rather than the legacy Api::V1::BannersController, so a `type` of
  // series/cruise/ground can filter which slides come back (Slide#tab_types).
  getSlides(category: string, type?: string): Promise<Banner[]> {
    return axiosInstance.get("/b2c2b/api/v1/slides", { params: { category, type } })
      .then(response => {
        const slides = response.data.data.map(({ attributes }) => {
          const banner: Banner = {
            title: attributes.title,
            url: attributes.url,
            target: attributes.target,
            sortOrder: attributes.sort_order,
            desktopImage: normalizeActiveStorageUrl(attributes.desktop_image),
            mobileImage: normalizeActiveStorageUrl(attributes.mobile_image)
          }
          return banner;
        });
        return Promise.resolve(slides);
      });
  }

}

export default BannersApi;
